import React from 'react'
import { Card, Collapse, Row } from 'antd'
import * as styles from '@pages/Logs/Log/style.scss'
import moment from 'moment'

const { Panel } = Collapse

function ViewLog(props) {
    const { creator, type, subType, date, attributes } = props.log

    const getObjectData = obj => {
        const res = []
        for (let key in obj) {
            if (typeof obj[key] === 'object') {
                res.push(
                    <Collapse key={key}>
                        <Panel header={key} key={key}>
                            <div key={key}>{getObjectData(obj[key])} </div>
                        </Panel>
                    </Collapse>
                )
            } else {
                res.push(
                    <div key={key} className={styles.mainLogInfo}>
                        {key} : {obj[key]}
                    </div>
                )
            }
        }
        return res
    }

    return (
        <Card title="Log">
            <Row className={styles.mainLogInfo}>creator: {creator} </Row>
            <Row className={styles.mainLogInfo}>Type: {type} </Row>
            <Row className={styles.mainLogInfo}>subType: {subType} </Row>
            <Row className={styles.mainLogInfo}>date: {moment(date).format('DD/MM/YY HH:mm:ss')} </Row>
            <Collapse>
                <Panel header="Attributes" key="1">
                    {getObjectData(attributes)}
                </Panel>
            </Collapse>
        </Card>
    )
}

export default ViewLog
